import React from "react";
import empty from "../../static/img/team/empty.jpg";
import {getUrlFromImage} from "../util/CommonUtil";

const TeamLid = (props) => (
    <div className="team-lid">
        <div className="team-lid-image"
             style={{background: `url(${props && props.teamlid && props.teamlid.image ? getUrlFromImage(props.teamlid.image) : empty}) top center / cover no-repeat`}}>
        </div>
        <div className="content">
            <h4 className="naam">{props.teamlid.naam}</h4>
            <h5 className="functie">{props.teamlid.functie}</h5>
            <div className="info">

            {props.teamlid.opleiding ? <p>
                <b>Opleiding:</b> <br/>
                {props.teamlid.opleiding}
            </p> : ''}
              {props.teamlid.interesse ? <p>
                <b>Bijzondere interesse:</b> <br/>
                {props.teamlid.interesse}
            </p> : ''}
              {props.teamlid.quote ? <p>
                <b>Quote:</b> <br/>
                {props.teamlid.quote}
            </p> : ''}
            </div>

        </div>
    </div>
);

export default TeamLid;